import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import { Subject, Observable } from 'rxjs';
import { YetiSocket } from '../yeti-socket';
import { environment } from 'src/environments/environment';
import { StringHelper } from 'src/app/helper/string/string-helper';
import { ISitePerformance } from 'src/app/interface/site';

@Injectable({
	providedIn: 'root',
})
export class SitePerformanceUpdatedService {
	private echo: Echo<any>;
	private subject: Subject<IResponse>;

	constructor() {
		this.echo = YetiSocket.connect();
		this.subject = new Subject<IResponse>();
	}

	public listener(
		companyId?: number,
		routePerformanceId?: number
	): Observable<IResponse> {
		if (companyId) {
			const channelEvent = StringHelper.sprintf(
				'%s_%d',
				environment.socketChannel,
				companyId
			);
			const listenEvent = StringHelper.sprintf(
				'.site_performance_updated_%d',
				routePerformanceId
			);
			this.echo.channel(channelEvent).stopListening(listenEvent);
			this.echo
				.channel(channelEvent)
				.listen(
					listenEvent,
					(data: any) => this.subject.next(data));
		}
		return this.subject.asObservable();
	}

	public local(sitePerformances: Array<ISitePerformance>) {
		this.subject.next({ site_performances: sitePerformances });
	}
}

interface IResponse {
	message?: string;
	site_performances?: Array<ISitePerformance>;
}
